<template>
    <button
        class="flex items-center gap-2 py-1.5 px-3 bg-white border border-won-green rounded"
        @click="clickHandler"
    >
        <UserGroupIcon
            class="text-won-green size-[18px]"
        />

        <span class="text-won-green text-base font-[Roboto] font-medium">
            Share
        </span>
    </button>
</template>

<script setup>
import { toRefs } from "vue";
import { useResumeShare } from "../../store/share-resume.store";
import { UserGroupIcon } from "@heroicons/vue/24/outline";

const emit = defineEmits(["click-handler"]);
const props = defineProps({
		emitClickEvent: {
				type: Boolean,
				default: false
		}
})
const { emitClickEvent } = toRefs(props);

const resumeShareStore = useResumeShare();

const clickHandler = () => {
		if(emitClickEvent.value) {
				emit('click-handler');
		}else{
				resumeShareStore.setShowShareModal();
		}
}
</script>
